import React from 'react';
import PropTypes from 'prop-types';

import { useTheme } from '@material-ui/core/styles';
import Avatar from '@material-ui/core/Avatar';
import Badge from '@material-ui/core/Badge';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Checkbox from '@material-ui/core/Checkbox';
import Divider from '@material-ui/core/Divider';
import Icon from '@material-ui/core/Icon';
import IconButton from '@material-ui/core/IconButton';
import InputAdornment from '@material-ui/core/InputAdornment';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import MenuList from '@material-ui/core/MenuList';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import Paper from '@material-ui/core/Paper';
import Skeleton from '@material-ui/lab/Skeleton';
import Typography from '@material-ui/core/Typography';

import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';
import SearchIcon from '@material-ui/icons/Search';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import ClearIcon from '@material-ui/icons/Clear';

import * as math from '_core/utils/math';
import * as search from '_core/utils/search';


export const BooleanValue = React.memo((props) => {
  const {
    l,
    
    column,
    data
  } = props;
  
  
  const value = math.getField(data, column.nameSplit[0]);
  
  return value === undefined ? '-' : value ? l('$global.field.yes') : l('$global.field.no');
});

export const BooleanFilter = React.memo((props) => {
  const {
    l,
    classes,
    
    filterValue,
    setFilterValue,
    
    filterApply,
    filterReset
  } = props;
  
  
  return (
    <>
      <Divider />
      
      <MenuItem onClick={() => setFilterValue(filterValue !== 1 ? 1 : null)}>
        <ListItemText primary={l('$global.field.yes')} />
        <ListItemSecondaryAction>
          <Checkbox
            edge="end"
            onChange={() => setFilterValue(filterValue !== 1 ? 1 : null)}
            checked={filterValue === 1}
          />
        </ListItemSecondaryAction>
      </MenuItem>
      
      <MenuItem onClick={() => setFilterValue(filterValue !== 0 ? 0 : null)}>
        <ListItemText primary={l('$global.field.no')} />
        <ListItemSecondaryAction>
          <Checkbox
            edge="end"
            onChange={() => setFilterValue(filterValue !== 0 ? 0 : null)}
            checked={filterValue === 0}
          />
        </ListItemSecondaryAction>
      </MenuItem>
    </>
  );
});

export const BooleanTags = React.memo((props) => {
  const {
    l,
    classes,
    
    filterApply,
    value
  } = props;
  
  
  return (
    <div className={classes.statusChip}>
      {value ? l('$global.field.yes') : l('$global.field.no')}
      
      <a href="" onClick={(event) => { event.preventDefault(); filterApply(null); }}><ClearIcon /></a>
    </div>
  );
});

export const getBooleanApiParam = (column, value) => {
  return value ? 1 : 0;
};

export const getBooleanExportValue = async (props, column, data) => {
  const {
    l
  } = props;
  
  
  const value = math.getField(data, column.nameSplit[0]);
  
  return value === undefined ? '-' : value ? l('$global.field.yes') : l('$global.field.no');
};
